// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top[data-v-c0183fec]{background-color:#fff}.h1Title[data-v-c0183fec]{padding-top:20px;height:30px;margin:10px 0 20px 20px;font-family:MicrosoftYaHei-Bold;font-size:16px;color:#080707;letter-spacing:0;font-weight:700}.dateTitle[data-v-c0183fec]{font-family:MicrosoftYaHei;font-size:12px;color:#333;letter-spacing:0;height:20px;margin:20px 0 20px 20px}", ""]);
// Exports
module.exports = exports;
